import React, { useState } from "react";
import ToDoCmpnt from "./ToDoCmpnt";
import "./index.css";
import InputArea from "./InputArea";


function App() {
  
  const [items, setItems] = useState([]);


  function addItem(inputText) {
    setItems((prevItems) => {
      return [...prevItems, inputText];
    });
  
  }

  function deleteItem(id) {
    setItems((prevItems) => {
      return prevItems.filter((item, index) => {
        return index !== id;
      });
    });
  }

  return (
    <div className="container">
      <div className="heading">
        <h1>To-Do List</h1>
      </div>
      <InputArea
      onAdd={addItem} />
      <div>
        <ul>
          {items.map((todoItem, index) => (
            <ToDoCmpnt
              key={index}
              id={index}
              text={todoItem}
              onChecked={deleteItem}
            />
          ))}
        </ul>
      </div>
    </div>
  );
}

export default App;
